var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpillBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "9 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.34604,
    y: 17.8725,
    width: 12,
    height: 12,
    transform: "rotate(22.1007 5.34604 17.8725)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.439,
    y: 44.1671,
    width: 15.8358,
    height: 15.8358,
    transform: "rotate(119.806 25.439 44.1671)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7807,
    y: 2.40973,
    width: 12,
    height: 12,
    transform: "rotate(101.584 18.7807 2.40973)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.063,
    y: 28.0736,
    width: 7.24217,
    height: 7.24217,
    transform: "rotate(81.6039 28.063 28.0736)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8525,
    y: 18.7552,
    width: 4.70446,
    height: 4.70446,
    transform: "rotate(99.2373 32.8525 18.7552)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 37.2377,
    y: 34.7006,
    width: 4.70446,
    height: 4.70446,
    transform: "rotate(80.7227 37.2377 34.7006)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 27.1476,
    y: 6.62476,
    width: 4.70446,
    height: 4.70446,
    transform: "rotate(61.6179 27.1476 6.62476)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 38.7793,
    y: 29.567,
    width: 2.2272,
    height: 2.2272,
    transform: "rotate(61.6179 38.7793 29.567)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 44.8446,
    y: 44.0403,
    width: 2.2272,
    height: 2.2272,
    transform: "rotate(-4.00091 44.8446 44.0403)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3289,
    y: 17.8725,
    width: 2.2272,
    height: 2.2272,
    transform: "rotate(61.6179 38.3289 17.8725)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpillBottom);
export default __webpack_public_path__ + "static/media/spill-bottom.2b706b5c7f1c9348845939a577ebfb2a.svg";
export { ForwardRef as ReactComponent };